import { Flex, Icon, Th } from "@chakra-ui/react";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import { parseSortValue } from "../Os/osDateUtils";
import styles from "./Home.module.css";

export default function HomeSortableTh({
  children,
  field,
  sortBy,
  onColumnSort,
  defaultDirection = "asc",
  ...props
}) {
  const { field: activeField, direction } = parseSortValue(sortBy);
  const isActive = activeField === field;

  return (
    <Th
      {...props}
      cursor="pointer"
      userSelect="none"
      onClick={() => onColumnSort(field, defaultDirection)}
      className={styles.sortableTh}
      aria-sort={
        isActive ? (direction === "asc" ? "ascending" : "descending") : "none"
      }
    >
      <Flex align="center" gap={1}>
        {children}
        {isActive && (
          <Icon
            as={direction === "asc" ? FiChevronUp : FiChevronDown}
            boxSize={3.5}
            color="#C1272D"
          />
        )}
      </Flex>
    </Th>
  );
}
